<template>
  <b-row
    v-if="visible"
    class="mt-4"
  >
    <b-col cols="12">
      <b-form-group class="mb-0">
        <div class="replace-product-box border rounded p-3">
          <b-table
            :items="items"
            :fields="fields"
            small
            bordered
            hover
            class="mb-4"
            show-empty
            empty-text="Chưa có linh kiện xuất kho."
          >
            <template #cell(stt)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(createdByName)="data">
              <span
                class="font-weight-bold"
                v-b-tooltip.hover.top
                title="Tên người lập phiếu xuất linh kiện"
                >{{ data.item.createdByName }}</span
              ><br />
              <span
                class="text-muted small"
                v-b-tooltip.hover.top
                title="Mã nhân viên lập phiếu xuất linh kiện"
                >({{ data.item.createdByCode }})</span
              >
            </template>
            <template #cell(productName)="data">
              <ProductCommonInfo :product="data.item" />
              <span
                v-if="data.item.imeiCode"
                class="text-primary small font-italic d-block mt-1"
              >
                IMEI: {{ data.item.imeiCode }}
              </span>
              <div class="pt-2">
                <small v-if="data.item.stockSlipCode">
                  Phiếu kho:
                  <span
                    class="text-primary font-weight-bold hover-link"
                    @click="openStockSlip(data.item)"
                  >
                    {{ data.item.stockSlipCode }}
                  </span></small
                ><br />
                <small v-if="data.item.exportReasonName">
                  Lý do:
                  <span class="font-weight-bold">
                    {{ data.item.exportReasonName }}
                  </span></small
                >
              </div>
            </template>
            <template #cell(quantity)="data">
              {{ data.item.quantity ?? '—' }}
            </template>
            <template #cell(totalAmount)="data">
              {{ convertPrice(data.item.totalAmount) }}
            </template>
            <template
              v-if="items.length"
              #bottom-row
            >
              <td
                colspan="3"
                class="font-weight-bolder text-right"
              >
                Tổng số:
              </td>
              <td class="text-right font-weight-bolder">
                {{ totalQuantity }}
              </td>
              <td class="text-right font-weight-bolder text-success">
                {{ convertPrice(totalAmountSum) }}
              </td>
            </template>
          </b-table>
        </div>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import ProductCommonInfo from '@/view/components/products/ProductCommonInfo.vue'
import { convertPrice } from '@/utils/common'

export default {
  name: 'ReplaceProductsTable',
  components: {
    ProductCommonInfo,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    showWhenEmpty: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visible() {
      return this.showWhenEmpty || (Array.isArray(this.items) && this.items.length > 0)
    },
    totalQuantity() {
      if (!Array.isArray(this.items)) return 0
      return this.items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0)
    },
    totalAmountSum() {
      if (!Array.isArray(this.items)) return 0
      return this.items.reduce((sum, item) => sum + (Number(item.totalAmount) || 0), 0)
    },
    fields() {
      return [
        {
          key: 'stt',
          label: 'STT',
          thStyle: { width: '2%', textAlign: 'center' },
          tdClass: 'text-center',
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
          thStyle: { width: '30%', textAlign: 'center' },
        },
        {
          key: 'createdByName',
          label: 'Người lập phiếu',
          thStyle: { width: '20%', textAlign: 'center' },
          tdClass: 'text-center',
        },
        {
          key: 'quantity',
          label: 'SL',
          thStyle: { width: '2%', textAlign: 'center' },
          tdClass: 'text-right',
        },
        {
          key: 'totalAmount',
          label: 'Thành tiền',
          thStyle: { width: '10%', textAlign: 'center' },
          tdClass: 'text-right',
        },
      ]
    },
  },
  methods: {
    convertPrice,
    openStockSlip(item) {
      if (!item?.stockSlipId) return
      const route = this.$router.resolve({
        name: 'edit-inventory-dispatch',
        query: { id: item.stockSlipId },
      })
      window.open(route.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.replace-product-box {
  min-height: 100px;
  background-color: #fafafa;
}
.hover-link {
  cursor: pointer;
  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
}
</style>
